var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2402 9.44115C5.58139 9.08175 5.58139 8.50129 5.2402 8.14189L2.125 4.83382L5.2402 1.57183C5.58139 1.21243 5.58139 0.631974 5.2402 0.272568C5.07496 0.0981229 4.85004 0 4.6154 0C4.38076 0 4.15583 0.0981229 3.9906 0.272568L0.259396 4.17958C0.092801 4.3526 -0.00090638 4.58813 -0.00090638 4.83382C-0.00090638 5.07952 0.092801 5.31504 0.259396 5.48807L3.9906 9.44115C4.15583 9.6156 4.38076 9.71372 4.6154 9.71372C4.85004 9.71372 5.07496 9.6156 5.2402 9.44115V9.44115Z",
    fill: "#E86A0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBackArrow);
export default __webpack_public_path__ + "static/media/orange-back-arrow.2d590b4053ba591df65a98d9425739a8.svg";
export { ForwardRef as ReactComponent };